module.exports = __webpack_public_path__ + "static/media/small_mclaren.2ed52c5d.png";